import { render, staticRenderFns } from "./DocumentAttachmentDetailUpload.vue?vue&type=template&id=1ceda16b"
import script from "./DocumentAttachmentDetailUpload.vue?vue&type=script&lang=js"
export * from "./DocumentAttachmentDetailUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports